module.exports = __webpack_public_path__ + "static/Avenir-Heavy-d2415e64724aab17d7e4b36a17004510.woff";